<template>
    <div class="loader">
        <svg v-if="loader === 'rolling'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
             preserveAspectRatio="xMidYMid" width="200px" height="200px"
             class="svg-loader loader-rolling" style="background: none;">
            <circle cx="50" cy="50" fill="none" stroke="#FFF" stroke-width="5" r="35"
                    stroke-dasharray="150 50" transform="rotate(114 50 50)">
                <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
                                  keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
            </circle>
        </svg>
    </div>
</template>

<script>
    export default {
        name: 'loader',
        props: ['loader']
    }
</script>

<style lang="scss">
    .loader {
        width: 100px;
        height: 100px;
        margin: 0 auto;
    }

    .svg-loader {
        height: inherit;
        width: inherit;
    }
</style>


// WEBPACK FOOTER //
// Loaders.vue?0826eef5